<template>
  <div class="d-flex flex-grow-1 flex-column">
    <div class="p-4">
      <el-row>
        <el-button type="text" :disabled="rows.length === 0" :loading="exportBtnLoading" @click="handleExport">
          <i class="bi bi-box-arrow-in-left text-base" />导出Excel
        </el-button>
      </el-row>
      <el-form label-position="left" label-width="100px">
        <el-form-item label="填报月份:" prop="date">
          <el-date-picker
            v-model="query.date"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择填报月份"
            :picker-options="endDateOpt"
          />
        </el-form-item>
        <el-form-item label="区域:">
          <el-cascader
            :show-all-levels="false"
            style="width: 300px;"
            :options="options"
            :props="{ checkStrictly: true }"
            clearable
            v-model="query.area"
            @change="onAreaChange"
          />
        </el-form-item>

        <div class="relative shadow-md sm:rounded-lg">
          <table class="border-collapse border border-slate-400 text-sm text-center dark:text-gray-400">
            <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr v-for="row in [2,3,4,5]" :key="row">
                <template v-if="row === 2">
                    <th class="py-1 px-2 border border-slate-300 whitespace-nowrap" rowspan="4">地区/公司</th>
                    <th class="py-1 px-2 border border-slate-300 whitespace-nowrap" rowspan="4">下级地区/公司</th>
                </template>

                <template
                  v-for="(item, index) in hData['row' + row]"
                >
                  <th
                    :key="`${row}_${index}`" class="py-1 px-2 align-center border border-slate-300 whitespace-nowrap"
                    :colspan="item.colspan ? item.colspan : 1"
                    :rowspan="item.rowspan ? item.rowspan : 1"
                  >
                    {{ item.name }}
                  </th>
                </template>
              </tr>
            </thead>
            <template v-if="rows.length > 0">
              <template v-for="(row, row_index) in rows">
                <tr v-for="(item, index) in row.items" :key="`${row_index}_${index}`">
                  <th
                    v-if="index === 0" class="py-1 px-2 border border-slate-300 whitespace-nowrap"
                    :rowspan="row.items.length"
                  >
                    <a>{{ row.name }}</a>
                  </th>
                  <th class="py-1 px-2 border border-slate-300 whitespace-nowrap">
                    <template v-if="auth.user.role === $window.AREA.PROVINCE">
                      {{ item.name }}
                    </template>
                    <template v-else>{{ item.name }}</template>
                  </th>
                  <template
                    v-for="(data_item, data_index) in row_keys"
                  >
                    <th
                      :key="`${index}_${data_index}`" class="py-1 px-2 border border-slate-300 whitespace-nowrap"
                    >
                      {{ item[data_item] }}
                    </th>
                  </template>
                </tr>
              </template>
            </template>
            <template v-else>
              <tr>
                <th colspan="64" class="py-1 px-2 text-left">暂无数据</th>
              </tr>
            </template>
          </table>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Layout2 from '../../Shared/Layout2'
import {areas, hData, row_keys} from '../../utils'
console.log(hData)
export default {
  layout: Layout2,
  middleware: ['auth'],
  metaInfo() {
    return {title: '数据填报'}
  },
  props: {
    auth: {
      type: Object,
      default: () => ({}),
    },
    companies: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // options: [],
      queryDate: [],
      visible: false,
      detailLoading: false,
      exportBtnLoading: false,
      deptDataStatus: -1, //部门当前选择月填报状态，默认未填报
      rows: [],
      detailRows: [],
      loading: false,
      hData,
      row_keys,
      rules: {
        date: [{required: true, message: '请输入填报月份', trigger: 'blur'}],
      },
      endDateOpt: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
      query: {
        date: '',
        area: []
      },
    }
  },
  computed: {
    options() {
      let _areas = []
      for (let city_index in areas) {
        const city = areas[city_index]
        let children = []
        for (let district_index in city.children) {
          const district = city.children[district_index]

          children.push({value: district.value, label: district.label, children: (city.value in this.companies && district.value in this.companies[city.value])  ? this.companies[city.value][district.value] : []})
        }
        _areas.push({value: city.value, label: city.label, children: children})
      }
      // this.options = [{
      //   value: 'hn',
      //   label: '全省',
      //   children: _areas
      // }]
      if (this.auth.user.role === window.AREA.PROVINCE) {
        return [{
          value: 'hn',
          label: '全省',
          children: _areas,
        }]
      } else if (this.auth.user.role === window.AREA.CITY) {
        return _areas.filter(i => i.value === this.auth.user.city)
      } else {
        let _areas2 = []
        _areas.forEach(val => {
          if (val.value === this.auth.user.city) {
            val.children.forEach(k => {
              if (k.value === this.auth.user.district) {
                _areas2.push(k)
              }
            })
          }
        })
        return _areas2
      }
    },
  },
  watch: {
    'query.date': function (newVal, oldVal) {
      if (!newVal) {
        return
      }
      this.loadDeptData()
      // console.log('deptForm.date changed', newVal, oldVal)
      // axios.get('/dept/data', {params: {id: this.deptForm.id, date: newVal}}).then((res) => {
      //   if (res.data.status === 1) {
      //     this.deptDataStatus = -1
      //     this.rows = res.data.data
      //   } else {
      //     this.$message.error(res.data.message)
      //   }
      // })
    },
  }, mounted() {
    // this.deptForm = {
    //   id: this.auth.user.id,
    //   date: getLastMonth(),
    // }
    // let _areas = []
    // console.log(areas)
    // console.log(this.companies)
    // for (let city_index in areas) {
    //   const city = areas[city_index]
    //   console.log(city)
    //   let children = []
    //   for (let district_index in city.children) {
    //     const district = city.children[district_index]
    //
    //     children.push({value: district.value, label: district.label, children: (city.value in this.companies && district.value in this.companies[city.value])  ? this.companies[city.value][district.value] : []})
    //   }
    //   _areas.push({value: city.value, label: city.label, children: children})
    // }
    // console.log(_areas)
    // this.options = [{
    //   value: 'hn',
    //   label: '全省',
    //   children: _areas
    // }]
    // console.log(this.rules)
    // this.tableData.forEach(ele => {
    //   ele.rowspan = 1
    // })
    // this.tableData = this.tableData
    // for (let i = 0; i < this.tableData.length; i++) {
    //   for (let j = i + 1; j < this.tableData.length; j++) {
    //     console.log(this.tableData[i].Statistics)
    //     if (this.tableData[i].Statistics == this.tableData[j].Statistics) {
    //       this.tableData[i].rowspan++
    //       this.tableData[j].rowspan--
    //     }
    //   }
    //   // 这里跳过已经重复的数据
    //   i = i + this.tableData[i].rowspan - 1
    // }
  },
  methods: {
    onAreaChange() {
      this.loadDeptData()
    },
    loadDeptData() {
      console.log('loadDeptData', this.query)
      if (this.query.date.length === 0 || this.query.area.length === 0) {
        return
      }
      axios.get('/query/data', {params: this.query}).then((res) => {
        if (res.data.status === 1) {
          this.deptDataStatus = res.data.data_status
          this.rows = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    handleExport() {
      this.exportBtnLoading = true
      axios.get('/query/export', {params: this.query}).then((res) => {
        this.exportBtnLoading = false
        if (res.data.status === 1) {
          window.open(res.data.url)
          // for (let key in res.data.data) {
          //   this.form[key] = res.data.data[key]
          // }
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
